(function () {
 $('a.scroll').on('click', function (e) {
  e.preventDefault();
  console.log('click')

  var link = $(this);
  var el = $(link.attr('href'));
  var top = el.offset().top + 10;

  $('html, body').animate({ scrollTop: top }, 1000);
 });

 $('.main-header .arrow').on('click', function (e) {
  e.preventDefault()
  $('.main-header').toggleClass('active')
 })
})();


$(window).on('load', function () {
 var scene = document.getElementById('banner');
 var parallaxInstance = new Parallax(scene);
})

function initHighContrast() {
 let htmlTag = $('html');
 let highContrastBtn = $('.high-contrast-btn');

 if (localStorage.getItem('highContrastIkze') === 'true') {
  htmlTag.addClass('high-contrast');
 }

 highContrastBtn.on('click', (e) => {
  e.preventDefault();
  htmlTag.toggleClass('high-contrast');

  const isHighContrast = htmlTag.hasClass('high-contrast');
  localStorage.setItem('highContrastIkze', isHighContrast);
 });
}
initHighContrast();

function initSizePage() {
 let htmlTag = $('html');
 let changePageSizeButton = $('a[data-size-switcher]');

 if (localStorage.getItem('dataPageSizeIkze') !== null) {
  htmlTag.attr('data-font-size', localStorage.getItem('dataPageSizeIkze'));
  changePageSizeButton.removeClass('active');
  $(`a[data-size-switcher="${localStorage.getItem('dataPageSizeIkze')}"]`).addClass('active');
 } else {
  localStorage.setItem('dataPageSizeIkze', 'small');
 }

 changePageSizeButton.on('click', function (e) {
  e.preventDefault();
  changePageSizeButton.removeClass('active');
  $(this).addClass('active');
  let size = $(this).data('size-switcher');
  localStorage.setItem('dataPageSizeIkze', `${size}`);
  htmlTag.attr('data-font-size', size);
 });
}
initSizePage();